import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from './frontend/redux/reducers/index-reduces';
import initialState from './frontend/redux/reducers/initial-state';

const preloadedState = (typeof window === 'undefined') ? initialState : window.__PRELOADED_STATE__;
const composeEnhancers = (typeof window === 'undefined') ? compose() : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose();

const store = createStore(reducers, preloadedState, composeEnhancers(applyMiddleware(thunkMiddleware)));

export default store;
